package com.tixforgigs.common.ui.pages.template


import com.tixforgigs.apax.models.*
import com.tixforgigs.common.core.annotations.MissingTaramiIconKey
import com.tixforgigs.common.core.enums.View
import com.tixforgigs.common.core.extensions.RoutingUtil.AppScope
import com.tixforgigs.common.core.extensions.orElse
import com.tixforgigs.common.core.interfaces.StorefrontPage
import com.tixforgigs.common.core.util.TrackerUtil.pageView
import com.tixforgigs.common.core.util.UiUtil.APP_CONTAINER_ID
import com.tixforgigs.common.core.util.UiUtil.scrollTop
import com.tixforgigs.common.http.ApiGetPath
import com.tixforgigs.common.http.ApiPostPath
import com.tixforgigs.common.http.HttpClient.apiV4Get
import com.tixforgigs.common.http.HttpClient.apiV4Post
import com.tixforgigs.common.ui.components.grid.gridContainer
import com.tixforgigs.common.ui.components.mandarin.mandarinFilledButton
import com.tixforgigs.common.ui.components.mandarin.mandarinTitle
import com.tixforgigs.common.ui.components.root.defaultTemplate
import com.tixforgigs.common.ui.components.templateConfigurator.colorOptions
import com.tixforgigs.common.ui.components.templateConfigurator.customVarOptions
import com.tixforgigs.common.ui.components.templateConfigurator.defaultTemplateOptions
import com.tixforgigs.common.ui.components.templateConfigurator.fontOptions
import com.tixforgigs.mandarin.MandarinColors
import com.tixforgigs.tarami.AraiMessage.titleTemplateConfiguratorConfigDetail
import com.tixforgigs.tarami.GlobalMessage.buttonSave
import io.kvision.material.ExperimentalMaterialApi
import io.kvision.panel.SimplePanel
import io.kvision.panel.simplePanel
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.flow.updateAndGet
import kotlinx.coroutines.launch
import web.scroll.ScrollBehavior
import web.scroll.instant
import kotlin.time.ExperimentalTime
import kotlin.uuid.Uuid


@OptIn(ExperimentalMaterialApi::class, ExperimentalTime::class)
class TemplateConfiguratorDetailView(val templateId: Uuid) : SimplePanel(className = "xm-page xm-page-configurator"),
  StorefrontPage {

  override val VIEW: View
    get() = View.TEMPLATE_CONFIGURATION(templateId.toString())

  /*companion object {

    //TODO insert in MandarinTokenVar
    const val BG_IMAGE_DISPLAY = "--xm-background-image-display"
    const val HEADER_IMAGE_DISPLAY = "--xm-header-image-display"
    const val LIST_IMAGE_DISPLAY = "--xm-list-image-display"
    const val HEADLINE_FONT_FAMILY = "--xm-headline-font-family"
    const val CORNER_RADIUS = "--xm-corner-radius"
  }*/

  val templateConfigState = MutableStateFlow<TemplateConfig?>(null)
  val templateConfigType = MutableStateFlow<TemplateConfigType>(TemplateConfigType.CURRENT)

  val colorsListState = MutableStateFlow<List<ColorVariable>>(emptyList())
  val fontsListState = MutableStateFlow<List<FontVariable>>(emptyList())
  val customVarsListState = MutableStateFlow<List<CustomVariable>>(emptyList())

  val templateDataState = MutableStateFlow<TemplateData?>(null)
  val templateFilterState = MutableStateFlow<TemplateFilter?>(null)

  fun updateStates(template: TemplateConfig) {
    templateConfigState.updateAndGet { template }?.let { updatedTemplate ->
      updatedTemplate.configItems.firstOrNull { it.configType == templateConfigType.value }?.let { currentConfig ->
        colorsListState.update {
          //currentConfig.themeData?.colors.orEmpty()
          listOf(
            ColorVariable(MandarinColors.colorBackgroundBase.value, MandarinTokenVar.COLOR_BACKGROUND_BASE),
            ColorVariable(MandarinColors.colorForegroundBase.value, MandarinTokenVar.COLOR_FOREGROUND_BASE),

            ColorVariable(MandarinColors.colorFontBase.value, MandarinTokenVar.COLOR_FONT_BASE),
            ColorVariable(MandarinColors.colorFontSecondary.value, MandarinTokenVar.COLOR_FONT_SECONDARY),
            ColorVariable(MandarinColors.colorFontTertiary.value, MandarinTokenVar.COLOR_FONT_TERTIARY),
          )
        }
        fontsListState.update {
          //currentConfig.themeData?.fonts.orEmpty()
          listOf(
            FontVariable("Roboto", MandarinTokenVar.COLOR_FONT_BASE)
          )
        }
        customVarsListState.update { currentConfig.themeData?.vars.orEmpty() }

        templateDataState.update { currentConfig.templateData }
        templateFilterState.update { currentConfig.filter }
      }
    }
  }

  init {
    AppScope.launch {
      scrollTop(
        behavior = ScrollBehavior.instant,
        id = APP_CONTAINER_ID
      )
      apiV4Get<TemplateConfig>(
        type = ApiGetPath.TemplateConfigByTemplateId(templateId)
      )?.let { template ->
        updateStates(template)
      }
      pageView()
    }
    defaultTemplate {
      simplePanel(className = "xm-body") {
        gridContainer {
          gridItem(12) {
            mandarinTitle(titleTemplateConfiguratorConfigDetail())
          }
          gridItem(12) {
            defaultTemplateOptions(
              templateState = templateDataState,
              filterState = templateFilterState
            )
          }
          gridItem(12) {
            colorOptions(colorsListState)
          }
          gridItem(12) {
            fontOptions(fontsListState)
          }
          gridItem(12) {
            customVarOptions(customVarsListState)
          }
          gridItem(12) {
            @MissingTaramiIconKey
            mandarinFilledButton(
              title = buttonSave(),
              materialIconName = "save",
            ) {
              templateConfigState.value?.let { config ->
                apiV4Post<TemplateConfig>(
                  type = ApiPostPath.TemplateConfigUpdate(
                    templateId = templateId,
                    body = config.copy(
                      configItems = config.configItems.map { item ->
                        if (item.configType == templateConfigType.value) {
                          item.copy(
                            filter = templateFilterState.value.orElse { item.filter },
                            templateData = templateDataState.value.orElse { item.templateData },
                            themeData = item.themeData?.copy(
                              colors = colorsListState.value,
                              fonts = fontsListState.value,
                              vars = customVarsListState.value,
                            ),
                            previewData = item.previewData.copy(
                              embedCode = "<div>" //TODO quickfix for server error
                            )
                          )
                        } else item
                      }.toSet()
                    )
                  )
                )?.let { updatedConfig ->
                  updateStates(updatedConfig)
                }
              }
            }
          }
        }
      }
    }
  }

//  //TODO can be deleted?
//  private fun reloadStyle() {
//    val style = document.getElementById(ElementId("xm-theme-style")) as HTMLLinkElement?
//    style?.let { link ->
//      val href = URL(link.href)
//      href.searchParams.set("t", now().toEpochMilliseconds().toString())
//      link.href = href.toString()
//    }
//  }

}
